import './Theme.Button.MenuItem.scss';
export default 'ThemeButtonMenuItem';
